import type { NightsRange } from '../model/types';

export const MIN_NIGHTS = 1;
export const MAX_NIGHTS = 29;
export const DEFAULT_NIGHTS_RANGE: NightsRange = { from: 7, to: 10 };

export function clampNight(n: number): number {
  const rounded = Math.round(Number(n));
  if (Number.isNaN(rounded)) {
    return MIN_NIGHTS;
  }
  return Math.min(MAX_NIGHTS, Math.max(MIN_NIGHTS, rounded));
}

export function normalizeRange(range: NightsRange | null | undefined): NightsRange {
  if (!range) {
    return { ...DEFAULT_NIGHTS_RANGE };
  }
  const from = clampNight(range.from);
  const to = clampNight(range.to);
  return from > to ? { from: to, to: from } : { from, to };
}

export function setFrom(range: NightsRange, value: number): NightsRange {
  const from = clampNight(value);
  return { from, to: Math.max(from, range.to) };
}

export function setTo(range: NightsRange, value: number): NightsRange {
  const to = clampNight(value);
  return { from: Math.min(to, range.from), to };
}
